
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M21.39 38.01l-20.24-.13.04-6.19 17.61.12M3.29 31.64a17.47 17.47 0 012.52-8.42A19.91 19.91 0 009.6 11M18.79 19c-1.1-2.27-1.16-4.7-1.14-8M17.29 11a5.23 5.23 0 10-7.37-.13"}}),_c('rect',{attrs:{"x":"18.89","y":"18.06","width":"19.91","height":"19.91","rx":"2.21","transform":"rotate(-.33 29.436 27.865)","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"25.6","cy":"31.27","r":"2.25","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"32.1","cy":"24.77","r":"2.25","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M6.17 10.98h15"}})])
          )
        }
      }
    